var _path, _g, _path2, _rect, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsdtTon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 27,
    viewBox: "0 0 32 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1729_11960",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 27
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 0.645508H0V26.7983H32V0.645508Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1729_11960)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0764 26.4794C20.125 26.4794 25.8339 20.7705 25.8339 13.722C25.8339 6.67345 20.125 0.964478 13.0764 0.964478C6.02794 0.964478 0.31897 6.67345 0.31897 13.722C0.31897 20.7705 6.02794 26.4794 13.0764 26.4794Z",
    fill: "#26A17B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6393 14.6043C14.5542 14.6043 14.0971 14.6362 13.0871 14.6362C12.2791 14.6362 11.7157 14.6149 11.5137 14.6043C8.40936 14.4661 6.10238 13.9239 6.10238 13.286C6.10238 12.6481 8.41999 12.1059 11.5137 11.9571V14.0621C11.7157 14.0727 12.3004 14.1152 13.0977 14.1152C14.0652 14.1152 14.5436 14.0727 14.6286 14.0727V11.9677C17.7223 12.1059 20.0293 12.6481 20.0293 13.286C20.0399 13.9239 17.7329 14.4661 14.6393 14.6043ZM14.6393 11.7445V9.85212H18.9555V6.98169H7.20803V9.86275H11.5243V11.7445C8.016 11.9039 5.37946 12.6056 5.37946 13.4348C5.37946 14.2641 8.016 14.9657 11.5243 15.1252V21.1637H14.6393V15.1146C18.1369 14.9551 20.7735 14.2641 20.7735 13.4242C20.7735 12.5843 18.1476 11.9039 14.6393 11.7445Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3755 21.2076C28.5914 21.2076 32.0011 17.7979 32.0011 13.5821C32.0011 9.36625 28.5914 5.95654 24.3755 5.95654C20.1597 5.95654 16.75 9.36625 16.75 13.5821C16.75 17.7979 20.1597 21.2076 24.3755 21.2076Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.7067,
    y: 8.9176,
    width: 9.20731,
    height: 9.20728,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3756 6.28198C20.3441 6.28198 17.0756 9.55056 17.0756 13.582C17.0756 17.6134 20.3441 20.882 24.3756 20.882C28.407 20.882 31.6756 17.6134 31.6756 13.582C31.6756 9.55056 28.407 6.28198 24.3756 6.28198ZM21.8826 10.356H26.8685C27.7841 10.356 28.3662 11.3464 27.9057 12.1445L24.8282 17.4765C24.7822 17.5558 24.7162 17.6217 24.6367 17.6674C24.5573 17.7132 24.4672 17.7373 24.3756 17.7373C24.2839 17.7373 24.1938 17.7132 24.1144 17.6674C24.035 17.6217 23.9689 17.5558 23.923 17.4765L20.8466 12.1445C20.3855 11.3451 20.9665 10.356 21.8826 10.356ZM24.8294 11.2661V15.8772L25.4998 14.5827L27.1155 11.6895C27.1402 11.6462 27.1531 11.5973 27.1529 11.5475C27.1526 11.4977 27.1392 11.4488 27.114 11.4059C27.0889 11.3629 27.0528 11.3274 27.0095 11.3028C26.9661 11.2783 26.9171 11.2656 26.8673 11.2661H24.8294ZM21.8814 11.2673C21.8317 11.2667 21.7828 11.2793 21.7395 11.3038C21.6962 11.3282 21.6602 11.3636 21.635 11.4065C21.6098 11.4493 21.5964 11.498 21.5961 11.5477C21.5958 11.5974 21.6086 11.6463 21.6332 11.6895L23.2501 14.5815L23.9205 15.8772V11.2673H21.8814Z",
    fill: "#0088CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdtTon);
export default __webpack_public_path__ + "static/media/usdt_ton.db8261d69e80fa3da95900074cd73763.svg";
export { ForwardRef as ReactComponent };